//import Libraries
import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
// import gsap from 'gsap';

const scrollanimation = () => {
    let controller = new ScrollMagic.Controller();

    //Fix Navigation for scroll in Home.js
    let sceneNavigation = new ScrollMagic.Scene({
        triggerElement: '.Navigation',
        triggerHook: 0,
        duration: window.innerHeight
    })
    .setPin('.Navigation')
    .addTo(controller);
    
    //Fix ScrollSection while png moves down
    let sceneScrollSection = new ScrollMagic.Scene({
        triggerElement: 'body',
        triggerHook: -150,
        duration: window.innerHeight
    })
    .setPin('.ScrollSection')
    .addTo(controller);

    window.onload = ()=>{
        // $('.ScrollDown').toggleClass('hidden');
    }

    window.onscroll = (event) => {
        let currentY = window.scrollY ? window.scrollY : document.documentElement.scrollTop;

        let setVisible = (scrollPoint, selector, initialState) => {
            let obj = $(selector);
            if(currentY > scrollPoint && !obj.hasClass('hidden') === initialState){
                obj.toggleClass('hidden').toggleClass('visible');
            } else if(currentY < scrollPoint && obj.hasClass('hidden') === initialState){
                obj.toggleClass('hidden').toggleClass('visible');
            }
        }

        if(currentY < 800){
            $('#layer-1').css('transform', 'translate3d(0px, '+currentY+'px ,0px)');
            $('#layer-2-1').css('transform', 'translate3d(0px, '+currentY*-0.4+'px ,0px)');
            $('#layer-3').css('transform', 'translate3d(0px, '+currentY+'px ,0px)');
            $('#layer-3-1').css('transform', 'translate3d('+currentY*0.15+'px ,'+currentY*1.1+'px ,0px)');
            $('#layer-3-2').css('transform', 'translate3d('+currentY*-0.15+'px ,'+currentY*1.1+'px ,0px)');
            $('#layer-3-3').css('transform', 'translate3d('+currentY*-0.15+'px ,'+currentY*0.9+'px ,0px)');
            $('#layer-3-4').css('transform', 'translate3d('+currentY*0.15+'px ,'+currentY*0.9+'px ,0px)');
            $('#layer-4').css('transform', 'translate3d(0px, '+currentY*0.18+'px ,0px)');
            $('#layer-4-1').css('transform', 'translate3d(0px, '+currentY*0.3+'px ,0px)');
        }
        if(2000 < currentY && currentY < 2200){

        }

        if(document.getElementById('ScrollDown')){
            if(currentY > 1000 && !document.getElementById('ScrollDown').classList.contains("hidden")){
                document.getElementById('ScrollDown').classList.add("hidden")
            }
        }

        //Title Toggle Visibility
        setVisible( 800,'.ScrollSectionTitle', true );
        //ScrollDown Toggle Visibility
        // setVisible( 300,'.ScrollDown', false );
        //ScrollCards Toggle Visibility
        setVisible( 800,'.ScrollCards', false );
    }
}

export default scrollanimation;


// WEBPACK FOOTER //
// ./src/pages/Home/ScrollSection/animation.js